import { FormItem, FormItemsGroup, Link, SkeletonText, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EmberRoute } from '../../../../../../enums/emberRoute'
import { useEmberRouteUrl } from '../../../../../../hooks/routing/useEmberRouteUrl'
import { getContactFromBill } from '../../../../utils/getContactFromBill'
import { useBillView } from '../../contexts/billViewContext'

export const BillVendor = (): ReactElement => {
  const { t } = useTranslation()
  const { billData, isFetching, isFetchingInvalidation } = useBillView()
  const { bill, contacts } = billData || {}

  const vendor = bill ? getContactFromBill(bill, contacts) : undefined
  const isLoading = isFetching || (!vendor && isFetchingInvalidation)
  const { url: contactsSupplierUrl } = useEmberRouteUrl(EmberRoute.ContactsSupplier, vendor?.id)

  return (
    <FormItemsGroup>
      <FormItem label={t('bill.view.form.vendor')}>
        {isLoading ? (
          <SkeletonText variant="h4" width={100} />
        ) : (
          <Text variant="h4">
            <Link withAnimation to={contactsSupplierUrl}>
              {vendor?.name}
            </Link>
          </Text>
        )}
      </FormItem>
    </FormItemsGroup>
  )
}
